import { render, staticRenderFns } from "./showProject.vue?vue&type=template&id=49220cd0&scoped=true"
import script from "./showProject.vue?vue&type=script&lang=js"
export * from "./showProject.vue?vue&type=script&lang=js"
import style0 from "./showProject.vue?vue&type=style&index=0&id=49220cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49220cd0",
  null
  
)

export default component.exports